module.exports = __webpack_public_path__ + "img/site-selection-old.149c8750.svg";